
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// SCROLL LOCK
function scrollLock() {
  const body = document.querySelector('html');
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  body.style.position = 'fixed';
  body.style.width = '100%';
  body.style.height = '100%';
  body.style.overflow = 'hidden';
  body.style.top = `-${scrollY}`;
};

// SCROLL ABLE
function scrollAble() {
  const body = document.querySelector('html');
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  body.style.height = '';
  body.style.overflow = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', window.scrollY + 'px');
});

// LAZYLOADING
function lazyloading() {
  const IS_LOADED = 'is-loaded';
  const lazyloading = document.querySelectorAll('.lazyloading');

  if(lazyloading) {
    lazyloading.forEach((el) => {
      if(el.getBoundingClientRect().top <= window.innerHeight && 
        !el.classList.contains(IS_LOADED)) {
        if (el.dataset.src && (el.nodeName.toLowerCase() === 'img')) {
          el.setAttribute('src', el.dataset.src);
        } else {
          el.style.backgroundImage = "url("+el.dataset.src+")"
        }
        el.classList.add(IS_LOADED);
      } 
    });
  }
}

// MENU
function menu() {
  const burger = document.querySelector('#js-burger');
  const header = document.querySelector('#js-header');
  const drops = document.querySelectorAll('.js-menu-drop');
  const IS_ACTIVE = 'is-active';
  
  if(burger) {
    burger.addEventListener('click', e => {
      e.preventDefault();
      if(header.classList.contains(IS_ACTIVE)) {
        header.classList.remove(IS_ACTIVE);
        burger.classList.remove(IS_ACTIVE);
        if(drops) {
          drops.forEach((drop) => {
            drop.classList.remove(IS_ACTIVE);
            drop.nextElementSibling.classList.remove(IS_ACTIVE);
          });
        }
        scrollAble();
      } else {
        header.classList.add(IS_ACTIVE);
        burger.classList.add(IS_ACTIVE);
        scrollLock();
      }
    })
  }
  // MOBILE DROPDOWN
  if(drops) {
    drops.forEach((drop) => {
      drop.addEventListener('click', (el) => {
        if(el.target.nextElementSibling.classList.contains(IS_ACTIVE)) {
          el.target.nextElementSibling.classList.remove(IS_ACTIVE);
          el.target.nextElementSibling.nextElementSibling.style.maxHeight = 0;
        } else {
          el.target.nextElementSibling.classList.add(IS_ACTIVE);
          el.target.nextElementSibling.nextElementSibling.style.maxHeight = el.target.nextElementSibling.nextElementSibling.children[0].offsetHeight + 'px';
        }
      })

    })
    if(document.querySelectorAll('.sub-menu-item.has-sub-dropdown .u-show-sp')) {
      document.querySelectorAll('.sub-menu-item.has-sub-dropdown .u-show-sp').forEach(function(item) {
        item.addEventListener('click', (el) => {
          console.log(parseInt(el.target.parentNode.parentNode.parentNode.parentNode.parentNode.style.maxHeight));
          el.target.parentNode.parentNode.parentNode.parentNode.parentNode.style.maxHeight = 
          parseInt(el.target.parentNode.parentNode.parentNode.parentNode.parentNode.style.maxHeight) + el.target.nextElementSibling.children[0].offsetHeight + 'px'
          // this.parents('.menu-sub').style.maxHeight = this.parents('.menu-sub').style.maxHeight + 
        })
      })
    }
  }

  // MEGA MENU
  const button = document.querySelectorAll('.menu-link[aria-haspopup="true"]');
  if(window.innerWidth > 767) {
    if(button) {
      button.forEach(function(el) {
        const nextChild = el.nextElementSibling.nextElementSibling;
        el.addEventListener('mouseenter', function(e) {
          e.preventDefault;
          e.target.nextElementSibling.nextElementSibling.classList.add(IS_ACTIVE);
        })
        el.addEventListener('mouseleave', function(e) {
          e.preventDefault;
          e.target.nextElementSibling.nextElementSibling.classList.remove(IS_ACTIVE);
        })
        nextChild.addEventListener('mouseenter', function(e) {
          e.preventDefault;
          this.classList.add(IS_ACTIVE);
          e.target.previousElementSibling.previousElementSibling.classList.add(IS_ACTIVE);
        })
        nextChild.addEventListener('mouseleave', function(e) {
          e.preventDefault;
          this.classList.remove(IS_ACTIVE);
          e.target.previousElementSibling.previousElementSibling.classList.remove(IS_ACTIVE);
        })
      })
    }
  } 
}

/* HEADER SEARCH */
const searchButton = document.querySelector('#js-button-search');
const searchBar = document.querySelector('#js-search-bar');
const searchClose = document.querySelector('#js-search-close');
if(searchButton) {
  searchButton.addEventListener('click', function(e) {
    e.preventDefault();
    searchBar.style.maxHeight = searchBar.querySelector('.search').clientHeight + 'px';
  });
  searchClose.addEventListener('click', function(e) {
    searchBar.style.maxHeight = 0;
  });
}

/* ACCORDION */
function accordionPanel() {
  const accordTab = document.querySelectorAll('.accordion-item .accordion-tab');
  if(accordTab) {
    accordTab.forEach(function(tab) {
      setTimeout(function() {
        tab.parentNode.classList.add('is-open');
        tab.parentNode.querySelector('.accordion-content-wrap').style.maxHeight 
          = tab.parentNode.querySelector('.accordion-content').clientHeight + 'px';
      }, 200);  
      // tab.parentNode.querySelector('.accordion-content-wrap').style.maxHeight = 0;
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        if(parseInt(this.parentNode.querySelector('.accordion-content-wrap').style.maxHeight) !== 0) {
          this.parentNode.querySelector('.accordion-content-wrap').style.maxHeight = 0;
          this.parentNode.classList.remove('is-open');
        } else {
          this.parentNode.querySelector('.accordion-content-wrap').style.maxHeight 
          = this.parentNode.querySelector('.accordion-content').clientHeight + 'px';
          this.parentNode.classList.add('is-open');
        }
      });
    })
  }
}

/* モバイル第二階層の画像付きモバイルメニューで画像を選択した時に親要素のspanをクリックしたことにする */
document.querySelectorAll('.sub-menu-link.js-menu-drop').forEach(item => {
  item.addEventListener('click', e => {
    // クリックされた要素がimgであれば、その親要素であるspanがクリックされたとみなす
    if (e.target.tagName.toLowerCase() === 'img' || e.target.classList.contains('sub-link-title')){
      e.currentTarget.click(); // span要素をクリックする
    }
  });
});


/* SAME HEIGHT PRODUCT */
const matchHeight = function () {
	
	function init() {
		eventListeners();
		matchHeight();
	}
	
	function eventListeners(){
		$(window).on('resize', function() {
			matchHeight();
		});
	}
	
	function matchHeight(){
		var groupName = $('[data-match-height]');
		var groupHeights = [];
		
		groupName.css('min-height', 'auto');
		
		groupName.each(function() {
			groupHeights.push($(this).outerHeight());
		});
		
		var maxHeight = Math.max.apply(null, groupHeights);
		groupName.css('min-height', maxHeight);
	};
	
	return {
		init: init
	};
	
} ();

window.addEventListener('scroll', () => {
  lazyloading();
})

window.addEventListener('DOMContentLoaded', () => {
  lazyloading();
  menu();
  accordionPanel();
})

// $(document).ready(function() {
// 	matchHeight.init();
// });

document.addEventListener('DOMContentLoaded', function() {
  // Headerの高さを取得してmain要素に設定する関数
  function setMainPaddingTop() {
    // Headerの高さを取得
    const headerHeight = document.getElementById('headerFix').offsetHeight;

    // main要素にHeaderの高さ分のmargin-topを設定
    document.getElementById('page-content').style.paddingTop = headerHeight + 'px';
  }

  // 初回実行
  setMainPaddingTop();

  // 画面サイズが変更された場合に再度実行
  window.addEventListener('resize', setMainPaddingTop);
});

// アナウンスバー
function getSlideCount() {
  const slides = document.querySelectorAll('.announcement-bar__item');
  return slides.length;
}

const slideCount = getSlideCount();
if(slideCount > 1) {
  const swiperAnnuncement = new Swiper('.js-swiper-announcement-bar', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
    },
  });
}